import { useEffect, useState } from "react";
import { _EmployeeContract, _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _PayrollType, _PayrollTypeDuplicate } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { CDPsEditor } from "../../../contabilidad/budgetRPFactory/CDPsEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { SocialSecurityType } from "../SocialSecurityType";
import { ExcecuteRemoteAbstract } from "../../../system/remoteAbstractAction/ExcecuteRemoteAbstract";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PayrollLiquidateTypeSelect } from "../../PayrollLiquidateType/PayrollLiquidateTypeSelect";
import { PayrollFactorVdosSelect } from "../PayrollFactorVdos/PayrollFactorVdosSelect";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { PayrollTypeSelect } from "../PayrollFactor/PayrollTypeSelect";


export const PayrollType = () => {

    const PayrollType = useDataBean(_PayrollType);
    const duplicate = useDataBean(_PayrollTypeDuplicate);
    const single = Singleton.getInstance();
    const _employeeContracts = useDataBean(_EmployeeContract);
    const [remote, setRemote] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaladdpay, setModaladdpay] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalConfigurar = useModal("Configurar Tipos de Entidades de SeguridadSocial", MODAL_LG);
    const modalProfile = useModal("Configurar Propiedades del Perfil", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        PayrollType.instance.getPayrollTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        PayrollType.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const verpay = () => {
        setModaladdpay({ ...modaladdpay, "view": true });
    }
    const deleteItem = () => {
        PayrollType.deleteItemVoid(PayrollType.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PayrollType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const getRemote = () => {
        _employeeContracts.instance.getPayrollLiquidateProfileEditor(null).then(
            (resp) => {
                modalProfile.open()
                console.log(resp)
                setRemote(resp);
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const duplicatePayrollType = () => {
        duplicate.instance.duplicatePayrollType(duplicate.bean.IDPayrollType, duplicate.bean.Name).then(
            (resp) => {
                getLista();
                console.log(resp)
                setModaladdpay({ ...modaladdpay, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDPayrollType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Usar CDP', property: 'UseCDP', visible: true },
        { title: 'Tipo de Proceso de Liquidación de Nómina', property: 'PayrollLiquidateTypeName', visible: true },
        // { title: 'Cuenta por Pagar', property: 'PaymentAccountantIDStrName', visible: true },
        // { title: 'Cuenta de Gasto', property: 'ExpensiveAccountantIDStrName', visible: true },
        // { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'CDP', property: 'CDPDocumentName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PayrollType.bean.Name}`, "view": true }) } },
            { titulo: 'Configurar Tipos de Entidades de SeguridadSocial', icono: 'ri-edit-2-line', visible: true, evento: () => { modalConfigurar.open() } },
            { titulo: 'Configurar Propiedades del Perfil', icono: 'ri-edit-2-line', visible: true, evento: () => { getRemote() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Payroll">
            <div className="row">
                <div className="col-md-6">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verpay}>
                        Duplicar Payroll
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PayrollType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={PayrollType.bean.Name} onChange={PayrollType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <PayrollLiquidateTypeSelect idSelector={PayrollType.bean.IDPayrollLiquidateType} onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, "IDPayrollLiquidateType": e }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                <label>Factor de Configuración de Nómina</label>
                                <PayrollFactorVdosSelect render={PayrollType.bean.NamePayroll} idSelector={PayrollType.bean.IDPayrollFactor} onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, "IDPayrollFactor": e.IDPayrollFactor, "NamePayroll": e.Name }) }} label=" " returnType="Object" />
                            </div> */}
                            {/* <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta por Pagar" jsonCode={PayrollType.bean.PaymentAccountantIDStr} onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, "PaymentAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Gasto" jsonCode={PayrollType.bean.ExpensiveAccountantIDStr} onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <BasicSwitch label="Usar CDP" estado={PayrollType.bean.UseCDP} eventChange={(e: any) => { PayrollType.setBean({ ...PayrollType.bean, "UseCDP": e }) }} />
                            </div>
                            {PayrollType.bean.UseCDP &&
                                <>
                                    <div className="col-md-6">
                                        <CDPsEditor onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate, Mnemonic: e.Mnemonic, Consecutive: e.Consecutive }) }} value={PayrollType.bean.IDDocument} label="CDP" />
                                    </div>
                                </>
                            }
                            {/* <div className="col-md-6">
                                <SelectBudgetID label="Rubro Presupuestal" jsonCode={PayrollType.bean.BudgetIDStr} onChange={(e) => { PayrollType.setBean({ ...PayrollType.bean, "BudgetIDStr": e.JsonCode }) }} />
                            </div> */}

                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={PayrollType.bean.Description} onChange={PayrollType.handleChange} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PayrollType.bean.Name}</strong>
                    </ModalConfirm>
                    <Modal modal={modaladdpay} updateModal={setModaladdpay} eventModal={duplicatePayrollType}>
                        <div className="row">
                            <div className="col-md-12">
                                <PayrollTypeSelect idSelector={duplicate.bean.IDPayrollType} onChange={(e) => { duplicate.setBean({ ...duplicate.bean, "IDPayrollType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={duplicate.bean.Name} onChange={duplicate.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalConfigurar.modal} updateModal={modalConfigurar.setModal}>
                        <div className="row">
                            <div className="col">
                                <SocialSecurityType employeeLiquidate={PayrollType.bean} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalProfile.modal} updateModal={modalProfile.setModal}>
                        <div className="row">
                            <div className="col">
                                {remote.IDRemoteAbstractAction &&

                                    <ExcecuteRemoteAbstract remoteAbstractAction={remote} mapData={{ IDPayrollType: PayrollType.bean.IDPayrollType }} />
                                }
                                {/* <PrintJson json={remote} /> */}
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}